import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import jwt_decode from "jwt-decode";
import LayoutComponent from "../../components/shared/Layout";
import { Button, Tabs } from "react-bootstrap";
import { FaArrowsAltV } from "react-icons/fa";
import Info from "../../components/Info";
import FancyBet from "../../components/FancyBet";
import SportsBook from "../../components/SportsBook";
import SportWidget from "../../components/SportWidget";
import Bookmaker from "../../components/Bookmaker";
import SoccerBookmaker from "../../components/SoccerBookmaker";

import BattingIframe from "../../components/BattingIframe";
import PlaysBet from "../../components/PlaysBet";
import MarketDepth from "../../components/MarketDepth";
import MyBets from "../../components/MyBets";
import LoadingImage from "../../assets/images/cover-live.webp";
import LoadingImage2 from "../../assets/images/tvLoader.gif";
import ReactPlayer from "react-player";
import RightLogoTv from "../../assets/images/velki-logo.webp";
import { RiVolumeUpFill } from "react-icons/ri";
import {
  Navigate,
  useLocation,
  useNavigate,
  useParams,
  useRoutes,
} from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { inRange, isEmpty } from "lodash";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import {
  categoryArray,
  cricketScore,
  premiumCategoryArray,
  priceFormat,
} from "../../Utils/constants";
import Runner from "./Runner";
import { io } from "socket.io-client";
import BetSlipContext from "../../context/BetSlipContext";
import secureLocalStorage from "react-secure-storage";
import { Fade } from "react-awesome-reveal";
import StreamingPlayer from "./StreamingPlayer";
const FullMarket = () => {
  const parmas = useParams();
  const {
    user,
    profileData,
    setShowPosition,
    showWidget,
    setActiveWidget,
    activeWidget,
    parly,
    setSocketId,
    scoreAll,
    blockLimit,
  } = useContext(AuthContext);
  const {
    setBetSlipObject,
    setShowBetDialog,
    betSlipObject,
    showBetDialog,
    resetBetSlipObject,
    resetBetPosition,
    setResetBetPosition,
    betPlace,
    setLimit,
    setBetLoader,
  } = useContext(BetSlipContext);
  const ref = useRef(null);
  const [TvLoader, setTvLoader] = useState(LoadingImage);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const location = useLocation();

  const [fancySportTab, setFancySportTab] = useState("fancy");
  const [showInfo, setShowInfo] = useState(false);
  const [sportRules, setSportRules] = useState(false);
  const [showMarketDepthPopup, setShowMarketDepthPopup] = useState(false);
  const [marketDepthData, setMarketDepthData] = useState(false);
  const [showMyBet, setShowMyBet] = useState(false);
  const [topTab, setTopTab] = useState("live");
  const [detail, setDetail] = useState({});
  const [runner, setRunner] = useState([]);
  const [bookmaker, setBookmaker] = useState([]);
  const [fancy, setFancy] = useState([]);
  const [fancyHeader, setFancyHeader] = useState([]);
  const [sportsBook, setSportsBook] = useState([]);
  const [sportsBookHeader, setSportsBookHeader] = useState([]);
  const [mute, setMute] = useState(true);
  const [scrollHeight, setScrollHeight] = useState(75);
  const [runnerBackOdds, setRunnerBackOdds] = useState([]);
  const [runnerLayOdds, setRunnerLayOdds] = useState([]);
  const [bookmakerBackOdds, setBookmakerBackOdds] = useState([]);
  const [bookmakerLayOdds, setBookmakerLayOdds] = useState([]);
  const [fancyHeaderKey, setFancyHeaderKey] = useState("All");
  const [fancyUpdated, setFancyUpdate] = useState([]);
  const [position, setPosition] = useState([]);
  const [fancyPosition, setFancyPosition] = useState([]);
  const [marketName, setMarketName] = useState("Match Odds");
  const [sportsBookPosition, setSportsBookPosition] = useState([]);
  const [totalMatched, setTotalMatched] = useState(0);
  const [tieData, setTieData] = useState([]);
  const [tossData, setTossData] = useState([]);
  const [back_oddsTie, setBackOddsTie] = useState([]);
  const [lay_oddsTie, setLayOddsTie] = useState([]);
  const [betFairMs, setBetFairMs] = useState(1);
  const [widgetsData, setWidgetsData] = useState([]);
  const [checkRefresh, setCheckRefresh] = useState(true);
  const [controls, setControls] = useState(false);
  const [tvClass, setTvClass] = useState(false);
  const [socketObj, setSocketObj] = useState(null);
  const [marketNew, setMarketNew] = useState([]);
  const [activeSportBook, setActiveSportBook] = useState([]);
  const [marketId, setMarketId] = useState([]);
  const [bookmakerMs, setBookmakerMs] = useState(1);
  const [ruunnerToss, setRunnerToss] = useState([]);
  const [ruunnerTossObject, setRunnerTossObject] = useState([]);
  const [ruunnerTossOdds, setRunnerTossOdds] = useState([]);
  const [ruunnerTossPosition, setRunnerTossPosition] = useState([]);
  const [ms, setMs] = useState(0);
  const handleShowBet = () => {
    setShowMyBet(!showMyBet);
  };
  const handleShowInfo = () => {
    setShowInfo(!showInfo);
    if (fancySportTab === "sport") {
      setSportRules(!sportRules);
    }
  };

  const handleClick = (value) => {
    const pathParts = location.pathname.split("/");

    // Replace the last segment
    pathParts[pathParts.length - 1] = value;

    const updatedPath = pathParts.join("/");

    // Navigate without refreshing
    navigate(updatedPath, { replace: false });
  };

  const [favouriteList, setFavouriteList] = useState([]);
  const getMatchDetails = async (info) => {
    let userId = !isEmpty(localStorage.getItem("token"))
      ? jwt_decode(localStorage.getItem("token"))?.user?._id
      : "";
    let obj = { userId: userId, eventId: parmas?.eventId };
    const { status, data: response_users } = await apiGet(
      apiPath.matchDetail,
      obj,
    );
    if (status === 200) {
      if (response_users?.success) {
        if (response_users?.results?.marketList?.length > 1) {
          if (
            response_users?.results?.gameType == "cricket" ||
            response_users?.results?.gameType == "soccer"
          ) {
            let latest = response_users?.results?.marketList?.filter((res) => {
              return (
                res?.jsonData?.length > 0 && res?.market != "To Win the Toss"
              );
            });
            setMarketNew(latest || []);
            let updated = latest?.map((res) => {
              return res?.marketId;
            });
            if (updated?.length > 0) {
              setMarketId(updated);
            }
            let filteredArray = latest?.filter((res) => {
              return res?.marketId == parmas?.marketId;
            });
            setRunner(filteredArray[0]?.jsonData || []);
            setMarketName(filteredArray[0]?.market);
            let findToss = response_users?.results?.marketList?.find((res) => {
              return res?.market == "To Win the Toss";
            });
            if (!isEmpty(findToss)) {
              setRunnerToss(findToss?.jsonData);
              setRunnerTossObject(findToss);
            }
          } else {
            setMarketName("Match Odds");
            setRunner(response_users?.results?.jsonData || []);
          }
        } else {
          setMarketName("Match Odds");
          setRunner(response_users?.results?.jsonData || []);
        }
        setFavouriteList(
          response_users?.results?.favourites?.map((res) => {
            return res?.favoriteMarketId;
          }),
        );

        // Only pick the default tab on the initial load (not on polling/fav
        // refreshes), and use the fresh response, not the stale `detail` state.
        if (!info) {
          if (!isEmpty(parmas?.tab)) {
            setFancySportTab(parmas?.tab);
          } else if (response_users?.results?.hasFancy) {
            setFancySportTab("fancy");
          } else {
            setFancySportTab("sport");
          }
        }
        if (response_users?.results?.matchOdss?.length > 0) {
          listenBetfairOdds({ results: response_users?.results?.matchOdss });
        }

        setDetail(response_users?.results);
        const sortedData = (
          response_users?.results?.jsonBookmakerData || []
        ).sort((a, b) => a?.sortPriority - b?.sortPriority);

        setBookmaker(
          response_users?.results?.eventType == 4
            ? response_users?.results?.jsonData
            : sortedData || [],
        );

        setTieData(response_users?.results?.jsonTieData || []);
        getWidgets(response_users?.results);
        if (response_users?.results?.jsonData?.length > 0) {
          getBookmakerOdds();
        }
      }
    }
  };

  const getWidgets = async (detail) => {
    const { status, data: response_users } = await apiGet(apiPath.matchList, {
      seriesId: detail?.seriesId,
    });
    if (status === 200) {
      if (response_users?.success) {
        if (response_users?.results?.length > 0) {
          if (isEmpty(activeWidget)) {
            setActiveWidget(detail?._id);
          }
          setWidgetsData(response_users?.results);
        } else {
          setWidgetsData([]);
          setActiveWidget("");
        }
      }
    }
  };

  const getMatchOdds = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds + `?marketId=${!isEmpty(id) ? id : parmas.marketId}`,
    );
    if (status === 200) {
      if (response_users.success) {
        const socket_data = response_users?.results;
        if (
          socket_data &&
          socket_data?.eventId &&
          parmas?.eventId == socket_data?.eventId
        ) {
          if (socket_data.rt?.length) {
            const back_odds = socket_data.rt.filter((rt) => rt.ib) || [];
            const lay_odds = socket_data.rt.filter((rt) => !rt.ib) || [];
            setRunnerBackOdds(back_odds);
            setMs(socket_data?.ms);
            setRunnerLayOdds(lay_odds);
            setTotalMatched(socket_data?.totalMatched);
          }
        }
        if (!isEmpty(id)) {
          setCheckRefresh(true);
        }
      }
    }
  };

  const getBookmakerOdds = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookmakerOdds + `?eventId=${parmas.eventId}`,
    );
    if (status === 200) {
      if (response_users.success) {
        const message = response_users?.results;

        if (message.eventId === parmas?.eventId) {
          if (message.eventId === parmas?.eventId) {
            setBookmaker((prev) => {
              return prev?.map((res) => {
                let temp = message?.rt?.find((item) => {
                  return item?.name === res?.RunnerName;
                });
                if (temp?.name === res?.RunnerName) {
                  return {
                    ...res,
                    ...temp,
                  };
                } else {
                  return { ...res, ...temp };
                }
              });
            });
            const back_odds = message?.rt.filter((rt) => rt.ib) || [];
            const lay_odds = message?.rt.filter((rt) => !rt.ib) || [];
            setBookmakerLayOdds(lay_odds);
            setBookmakerMs(!isEmpty(message?.ms) ? message?.ms : 1);
            setBookmakerBackOdds(back_odds);
          }
        }
      }
    }
  };
  const getSportBookList = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.getPremiumFancy + `?eventId=${parmas.eventId}`,
    );
    if (status === 200) {
      if (response_users.success) {
        let filtered =
          response_users?.results?.data?.length > 0
            ? response_users?.results?.data?.filter((res) => {
                return res?.sportsBookSelection?.length > 0;
              })
            : [];
        let filteredHeader = premiumCategoryArray?.filter((f) =>
          filtered?.some((item) => item.categoryType === f.type),
        );
        setSportsBookHeader(filteredHeader);
        setSportsBook(
          filtered?.length > 0
            ? filtered?.map((res, index) => {
                return { ...res, check: index < 5 ? true : false };
              })
            : [],
        );
      }
    }
  };
  const getBetPositionToss = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPosition +
        `?eventId=${parmas.eventId}&type=${detail?.gameType}&marketId=${id}`,
    );
    if (status === 200) {
      if (response_users.success) {
        if (response_users?.results?.betFair?.length > 0) {
          setRunnerTossPosition(response_users?.results?.betFair);
          setRunnerToss((current) =>
            current.map((res) => {
              let obj = response_users?.results?.betFair.find(
                (item) => item?.selectionId == res?.SelectionId,
              );
              if (!isEmpty(obj)) {
                return {
                  ...res,
                  position:
                    obj?.selectionId == res?.SelectionId ? obj?.position : 0,
                  newPosition: 0,
                };
              } else {
                return {
                  ...res,
                  position: 0,
                  newPosition: 0,
                };
              }
            }),
          );
        }
      }
    }
  };
  const getBetPosition = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPosition +
        `?eventId=${parmas.eventId}&type=${detail?.gameType}&marketId=${
          !isEmpty(id) ? id : parmas?.marketId
        }`,
    );
    if (status === 200) {
      if (response_users.success) {
        updatePosition(response_users?.results);
      }
    }
  };
  const updatePosition = (object) => {
    setPosition(object);
    setRunner((current) =>
      object?.betFair?.length > 0
        ? current.map((res) => {
            let obj = object?.betFair.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            if (!isEmpty(obj)) {
              return {
                ...res,
                position:
                  obj?.selectionId == res?.SelectionId ? obj?.position : 0,
                newPosition: 0,
              };
            } else {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }
          })
        : current.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setBookmaker((current) =>
      object?.bookmaker?.length > 0
        ? current?.map((res) => {
            let obj = object?.bookmaker?.find(
              (item) => item?.selectionId == `B${res?.SelectionId}`,
            );
            return {
              ...res,
              position: obj?.position ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setTieData((current) =>
      object?.tie?.length > 0
        ? current?.map((res) => {
            let obj = object?.tie?.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            return {
              ...res,
              position:
                obj?.selectionId == res?.SelectionId ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
    setTossData((current) =>
      object?.toss?.length > 0
        ? current?.map((res) => {
            let obj = object?.toss?.find(
              (item) => item?.selectionId == res?.SelectionId,
            );
            return {
              ...res,
              position:
                obj?.selectionId == res?.SelectionId ? obj?.position : 0,
              newPosition: 0,
            };
          })
        : current?.map((res) => {
            return {
              ...res,
              position: 0,
              newPosition: 0,
            };
          }),
    );
  };
  const getFancyBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betFancyPosition +
        `?eventId=${parmas.eventId}&type=${detail.gameType}`,
    );
    if (status === 200) {
      if (response_users.success) {
        secureLocalStorage.setItem(
          "fancy",
          response_users?.results?.map((res) => {
            return {
              selectionId: res?.selectionId,
              position: res?.position,
              betRunPosition: res?.betRunPosition,
              fName: res?.fancyName,
            };
          }),
        );
        updatedFancyPosition(
          response_users?.results?.map((res) => {
            return {
              selectionId: res?.selectionId,
              position: res?.position,
              betRunPosition: res?.betRunPosition,
              fName: res?.fancyName,
            };
          }),
        );
      }
    }
  };
  const updatedFancyPosition = (object) => {
    setFancyPosition(object);
    setFancy((prev) => {
      return prev?.map((res) => {
        let obj = object?.find((item) => item.selectionId == res.selectionId);
        return {
          ...res,
          odds: res,
          position: !isEmpty(obj) ? obj?.position : "",
        };
      });
    });
    setFancyUpdate((prev) => {
      return prev?.map((res) => {
        let obj = object?.find((item) => item.selectionId == res.selectionId);
        return {
          ...res,
          odds: res,
          position: !isEmpty(obj) ? obj?.position : "",
        };
      });
    });
  };
  const getSportBookBetPosition = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPremiumFancyPosition +
        `?eventId=${parmas.eventId}&type=${detail.gameType}`,
    );
    if (status === 200) {
      if (response_users.success) {
        secureLocalStorage.setItem(
          "premiumFancy",
          response_users?.results || [],
        );
        setSportsBookPosition(response_users?.results);
        setSportsBook((current) => {
          return current?.map((res) => {
            let obj = response_users?.results?.filter((item) => {
              return item?.fancyName == res?.marketName;
            });
            if (obj?.length > 0 && obj[0]?.fancyName == res?.marketName) {
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((elem) => {
                  let temp = obj?.find(
                    (item) => elem?.id == item?.fancySelectionId,
                  );
                  return {
                    ...elem,
                    position: temp?.position,
                  };
                }),
              };
            } else {
              return res;
            }
          });
        });
      }
    }
  };
  const handelChangeFancyHeader = (id) => {
    setFancyHeaderKey(id);
  };

  const [runnerBackOddsOld, setRuunerBackOddsOld] = useState([]);
  const [runnerLayOddsOld, setRuunerlayOddsOld] = useState([]);

  useEffect(() => {
    if (!isEmpty(ruunnerTossObject)) {
      getMatchOddsToss(ruunnerTossObject?.marketId);
    }
  }, [ruunnerTossObject]);
  const getMatchOddsToss = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds + `?marketId=${!isEmpty(id) ? id : parmas.marketId}`,
    );
    if (status === 200) {
      if (response_users.success) {
        const socket_data = response_users?.results;
        if (socket_data.rt?.length) {
          const back_odds = socket_data.rt.filter((rt) => rt.ib) || [];
          const lay_odds = socket_data.rt.filter((rt) => !rt.ib) || [];
          setRunnerTossOdds({
            back_odds: back_odds,
            lay_odds: lay_odds,
            ms: socket_data?.ms,
            totalMatched: socket_data?.totalMatched,
          });
        }
        if (!isEmpty(id)) {
          setCheckRefresh(true);
        }
      }
    }
  };
  const listenBetfairOdds = (event) => {
    let toss = event?.results?.find(
      (item) => item.marketId == ruunnerTossObject?.marketId,
    );
    if (!isEmpty(toss)) {
      if (toss?.rt?.length) {
        const back_odds = toss?.rt?.filter((rt) => rt.ib) || [];
        const lay_odds = toss?.rt?.filter((rt) => !rt.ib) || [];
        setRunnerTossOdds({
          back_odds: back_odds,
          lay_odds: lay_odds,
          ms: toss?.ms,
          totalMatched: toss?.totalMatched,
        });
      }
    }
    const socket_data =
      (event &&
        event?.results?.find((item) => item.marketId == parmas?.marketId)) ||
      [];
    if (socket_data && parmas?.marketId == socket_data?.mi) {
      if (socket_data.ms) {
        setBetFairMs(socket_data.ms);
      }
      if (socket_data.rt?.length) {
        const back_odds = socket_data?.rt?.filter((rt) => rt.ib) || [];
        const lay_odds = socket_data?.rt?.filter((rt) => !rt.ib) || [];
        let newArray = [...back_odds].concat([...lay_odds]);

        setBetLoader((loaderPrev) => {
          if (!loaderPrev) {
            setBetSlipObject((prev) => {
              if (prev?.playType == "betFair") {
                if (newArray?.length > 0) {
                  let updated = newArray?.find((res) => {
                    return (
                      res?.ib == prev?.object?.ib &&
                      res?.ri == prev?.object?.SelectionId
                    );
                  });
                  handelBetFairPositions({
                    ...prev,
                    odds: updated?.rt,
                  });
                  return {
                    ...prev,
                    odds: updated?.rt,
                  };
                } else {
                  resetPosition("betFair");
                  setShowBetDialog(false);
                  return {
                    odds: "",
                    bidPrice: 0,
                    teamName: "",
                    betType: "",
                  };
                }
              } else {
                return prev;
              }
            });
          }
          return loaderPrev;
        });

        setRunnerBackOdds((prev) => {
          setRuunerBackOddsOld(prev);
          return back_odds;
        });
        setMs(socket_data?.ms);
        setRunnerLayOdds((prev) => {
          setRuunerlayOddsOld(prev);
          return lay_odds;
        });
        setTotalMatched(socket_data?.totalMatched);
      }
    }
  };

  const listenBookmakerData = (message) => {
    if (message.eventId === parmas?.eventId) {
      setBookmaker((prev) => {
        return prev?.map((res) => {
          let temp = message?.results?.rt?.find((item) => {
            return item?.name === res?.RunnerName;
          });
          if (temp?.name === res?.RunnerName) {
            return {
              ...res,
              ...temp,
            };
          } else {
            return { ...res, ...temp };
          }
        });
      });
      const back_odds = message?.results?.rt.filter((rt) => rt.ib) || [];
      const lay_odds = message?.results?.rt.filter((rt) => !rt.ib) || [];
      setBookmakerLayOdds(lay_odds);
      setBookmakerMs(!isEmpty(message?.results?.ms) ? message?.results?.ms : 1);
      setBookmakerBackOdds(back_odds);
    }
  };
  const [fancyPlus, setFancyPlus] = useState([]);
  const listenDiamondFancy = (message) => {
    if (message?.eventId === parmas?.eventId) {
      if (message?.results?.length > 0) {
        let filtered = categoryArray?.filter((f) =>
          message?.results?.some((item) => item?.categoryType === f.type),
        );
        setFancyHeader(
          filtered?.length > 0
            ? [
                { type: "All", name: "All" },
                ...filtered,
                { type: "Session", name: "Session" },
              ]
            : [
                { type: "All", name: "All" },
                { type: "Session", name: "Session" },
              ],
        );
        if (!isEmpty(user)) {
          setFancyPosition((prev) => {
            setFancy(
              message?.results?.map((res) => {
                let obj = prev?.find(
                  (item) => item.selectionId == res.selectionId,
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                  newPosition:
                    Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                };
              }),
            );
            setFancyUpdate(
              message?.results?.map((res) => {
                let obj = prev?.find(
                  (item) => item.selectionId == res.selectionId,
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                  newPosition:
                    Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                };
              }),
            );
            setFancyPlus(
              message?.results
                ?.filter((res) => {
                  return res?.name?.toLowerCase()?.includes("odd");
                })
                ?.map((res) => {
                  return {
                    ...res,
                    odds: res,
                    fancyName: res.name,
                  };
                }),
            );
            return prev;
          });
        } else {
          setFancy((prev) => {
            return message?.results?.map((res) => {
              let obj = prev?.find(
                (item) => item.selectionId == res.selectionId,
              );
              return {
                ...res,
                odds: res,
                fancyName: res.name,
                position: !isEmpty(obj) ? obj?.position : "",
                newPosition:
                  Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
              };
            });
          });
          setFancyUpdate((prev) => {
            return message?.results?.map((res) => {
              let obj = prev?.find(
                (item) => item.selectionId == res.selectionId,
              );
              return {
                ...res,
                odds: res,
                fancyName: res.name,
                position: !isEmpty(obj) ? obj?.position : "",
                newPosition:
                  Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
              };
            });
          });
          setFancyPlus(
            message?.results
              ?.filter((res) => {
                return res?.name?.toLowerCase()?.includes("odd");
              })
              ?.map((res) => {
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                };
              }),
          );
        }
      }
    }
  };
  const listenSportBook = (message) => {
    const socket_data = message;
    if (socket_data.results && socket_data.eventId == parmas.eventId) {
      if (!isEmpty(user)) {
        setSportsBookPosition((prev) => {
          setSportsBook((current) => {
            let updatedArray =
              socket_data?.results?.length > 0
                ? socket_data?.results?.map((res, index) => {
                    return { ...res, check: index < 5 ? true : false };
                  })
                : [];

            return updatedArray?.map((res) => {
              let obj = prev?.filter((item) => {
                return item?.fancyName == res?.marketName;
              });
              if (obj?.length > 0 && obj[0]?.fancyName == res?.marketName) {
                return {
                  ...res,
                  sportsBookSelection: res?.sportsBookSelection?.map((elem) => {
                    let temp = obj?.find(
                      (item) => elem?.id == item?.fancySelectionId,
                    );
                    return {
                      ...elem,
                      position: temp?.position,
                    };
                  }),
                };
              } else {
                return res;
              }
            });
          });
          return prev;
        });
      } else {
        // for (let temp of socket_data.results) {
        //   setSportsBook((current) => {
        //     if (current?.length == 0) {
        //       return socket_data.results.filter((res) => {
        //         return res?.sportsBookSelection?.length > 0;
        //       });
        //     } else {
        //       return current?.map((res, index) => {
        //         if (res?.sportsBookSelection?.length > 0) {
        //           if (res?.id == temp?.id) {
        //             return {
        //               ...res,
        //               sportsBookSelection: temp?.sportsBookSelection,
        //               marketStatus: temp?.marketStatus,
        //             };
        //           } else {
        //             return res;
        //           }
        //         }
        //       });
        //     }
        //   });
        // }
      }
    }
  };
  const handelBetFairPositions = (slipObj) => {
    let selectionsTemp = [...runner];
    // ?.map((res) => {
    //   return {
    //     ...res,
    //     position: res?.position || 0,
    //     newPosition: res?.newPosition || 0,
    //   };
    // });
    if (betSlipObject?.bidPrice > 0) {
      if (slipObj?.object?.ib) {
        let backProfit = Number(
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice),
        );
        let backLoss = Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              }
            }),
          );
        } else {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            }),
          );
        }
      } else {
        let backProfit = Number(betSlipObject?.bidPrice);
        let backLoss =
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              }
            }),
          );
        } else {
          setRunner(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            }),
          );
        }
      }
    }
  };
  const handelBetFairPositionsToss = (slipObj) => {
    let selectionsTemp = [...ruunnerToss];
    if (betSlipObject?.bidPrice > 0) {
      if (slipObj?.object?.ib) {
        let backProfit = Number(
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice),
        );
        let backLoss = Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setRunnerToss(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              }
            }),
          );
        } else {
          setRunnerToss(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            }),
          );
        }
      } else {
        let backProfit = Number(betSlipObject?.bidPrice);
        let backLoss =
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setRunnerToss(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              }
            }),
          );
        } else {
          setRunnerToss(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            }),
          );
        }
      }
    }
  };
  const handelFancyPositions = (slipObj) => {
    if (slipObj?.bidPrice >= 0) {
      let updatedFancy = fancy?.map((res) => {
        return {
          ...res,
          newPosition: res?.newPosition || 0,
          position: res?.position || 0,
        };
      });
      if (slipObj?.object?.ib) {
        let currentPosition = updatedFancy.find(
          (rl) => rl.selectionId == slipObj?.object?.selectionId,
        );
        if (
          Math.abs(currentPosition.position) !== 0 &&
          !isEmpty(currentPosition.type)
        ) {
          let backLoss = slipObj?.bidPrice + currentPosition.position;
          currentPosition.newPosition = backLoss;
          const result = updatedFancy.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyUpdate(result);
          setFancy(result);
        } else {
          let backLoss = slipObj?.bidPrice;
          currentPosition.newPosition = backLoss;
          const result = updatedFancy.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyUpdate(result);
          setFancy(result);
        }
      } else {
        let currentPosition = updatedFancy.find(
          (rl) => rl?.selectionId == slipObj?.object?.selectionId,
        );
        if (Math.abs(currentPosition?.position) > 0) {
          let backProfit = (slipObj?.bidPrice * slipObj.odds) / 100;
          currentPosition.newPosition = backProfit + currentPosition.position;
          const result = updatedFancy.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyUpdate(result);
          setFancy(result);
        } else {
          let backProfit = (slipObj?.bidPrice * slipObj?.odds) / 100;
          currentPosition.newPosition = backProfit;
          const result = updatedFancy.map((data) => {
            if (data.selectionId == currentPosition.selectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition).toFixed(2)
                : null;
            }
            return data;
          });
          setFancyUpdate(result);
          setFancy(result);
        }
      }
    }
  };

  const handelSportBookPositions = (slipObj) => {
    slipObj = betSlipObject;
    if (slipObj?.bidPrice >= 0) {
      let backProfit = (slipObj.odds - 1) * slipObj?.bidPrice;
      let backLoss = slipObj?.bidPrice;
      setSportsBook((current) => {
        return current?.map((rl) =>
          rl?.id == slipObj?.object?.marketId
            ? {
                ...rl,
                sportsBookSelection: rl?.sportsBookSelection?.map((res) => {
                  return res.id === slipObj?.object?.id
                    ? {
                        ...res,
                        position:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? res.position
                            : 0,
                        newPosition:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? Number(backProfit) + Number(res.position)
                            : Number(backProfit),
                      }
                    : {
                        ...res,
                        position:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? res.position
                            : 0,
                        newPosition:
                          res.position !== 0 && !isNaN(Math.abs(res.position))
                            ? Number(res.position) - Number(backLoss)
                            : -Number(backLoss),
                      };
                }),
              }
            : rl,
        );
      });
    }
  };

  const handelBookmakerPositions = (slipObj) => {
    let selectionsTemp = [...bookmaker]?.map((res) => {
      return {
        ...res,
        position: res?.position || 0,
        newPosition: res?.newPosition || 0,
      };
    });
    if (slipObj?.bidPrice > 0) {
      if (slipObj?.object.ib) {
        let backProfit = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
        let backLoss = Number(slipObj?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - Number(backLoss),
                };
              }
            }),
          );
        } else {
          let backProfit = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
          let backLoss = Number(slipObj?.bidPrice);

          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            }),
          );
        }
      } else {
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          let backProfit = Number(slipObj?.bidPrice);
          let backLoss = Number((slipObj?.odds / 100) * slipObj?.bidPrice);

          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + Number(backProfit),
                };
              }
            }),
          );
        } else {
          let backProfit = Number(slipObj?.bidPrice);
          let backLoss = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
          setBookmaker(
            selectionsTemp?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.SelectionId) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            }),
          );
        }
      }
    }
  };

  const handelTiePosition = (slipObj) => {
    let selectionsTemp = [...tieData]?.map((res) => {
      return {
        ...res,
        position: res?.position || 0,
        newPosition: res?.newPosition || 0,
      };
    });
    if (betSlipObject?.bidPrice > 0) {
      if (slipObj?.object?.ib) {
        let currentPosition = selectionsTemp.find(
          (rl) => rl.SelectionId == slipObj?.object?.ri,
        );
        let otherTeamPosition;
        let thirdTeamPosition;
        if (slipObj.RunnerName == "The Draw") {
          otherTeamPosition = selectionsTemp[0];
          thirdTeamPosition = selectionsTemp[1];
        } else {
          otherTeamPosition = selectionsTemp.find(
            (rl) =>
              rl.SelectionId !== slipObj?.object?.ri &&
              rl.RunnerName != "The Draw",
          );
          thirdTeamPosition = selectionsTemp[2] ? selectionsTemp[2] : false;
        }
        let backProfit = (betSlipObject.odds - 1) * betSlipObject?.bidPrice; //(slipObj.rt - 1) * betSelectionObj?.bidPrice;
        let backLoss = betSlipObject?.bidPrice;
        if (
          Math.abs(selectionsTemp[0]?.position) > 0 ||
          Math.abs(selectionsTemp[1]?.position) > 0
        ) {
          currentPosition.newPosition = currentPosition.position + backProfit;
          otherTeamPosition.newPosition = otherTeamPosition.position - backLoss;
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition =
              thirdTeamPosition.position - backLoss;
          }
          const result = selectionsTemp.map((data) => {
            if (data.SelectionId == currentPosition.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (data.SelectionId == otherTeamPosition.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (
              thirdTeamPosition &&
              data.SelectionId == thirdTeamPosition.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            return data;
          });
          setTieData(result);
        } else {
          currentPosition.newPosition = backProfit;
          otherTeamPosition.newPosition = -backLoss;
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition = -backLoss;
          }
          const result = selectionsTemp.map((data) => {
            if (data.SelectionId == currentPosition.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (data.SelectionId == otherTeamPosition.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            if (
              thirdTeamPosition &&
              data.SelectionId == thirdTeamPosition.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition.toFixed(2))
                : 0;
            }
            return data;
          });
          setTieData(result);
        }
      } else {
        let currentPosition = selectionsTemp.find(
          (rl) => rl.SelectionId == slipObj?.object?.ri,
        );
        let otherTeamPosition;
        let thirdTeamPosition;
        if (slipObj.RunnerName == "The Draw") {
          otherTeamPosition = selectionsTemp[0];
          thirdTeamPosition = selectionsTemp[1];
        } else {
          otherTeamPosition = selectionsTemp.find(
            (rl) =>
              rl.SelectionId !== slipObj?.object?.ri &&
              rl.RunnerName != "The Draw",
          );
          thirdTeamPosition = selectionsTemp[2] ? selectionsTemp[2] : false;
        }

        if (
          Math.abs(selectionsTemp[0]?.position) > 0 ||
          Math.abs(selectionsTemp[1]?.position) > 0
        ) {
          let backProfit = betSlipObject?.bidPrice;
          let backLoss = (betSlipObject.odds - 1) * betSlipObject?.bidPrice; //(slipObj.rt - 1) * betSelectionObj?.bidPrice;
          currentPosition.newPosition =
            Number(currentPosition?.position) - Number(backLoss);
          otherTeamPosition.newPosition =
            Number(otherTeamPosition?.position) + Number(backProfit);
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition =
              Number(thirdTeamPosition?.position) + Number(backProfit);
          }
          const result = selectionsTemp.map((data) => {
            if (data?.SelectionId == currentPosition?.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition)
                : 0;
            }
            if (data?.SelectionId == otherTeamPosition?.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition)
                : 0;
            }
            if (
              thirdTeamPosition &&
              data?.SelectionId == thirdTeamPosition?.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition)
                : 0;
            }
            return data;
          });
          setTieData(result);
        } else {
          let backProfit = betSlipObject?.bidPrice;
          let backLoss = (betSlipObject.odds - 1) * betSlipObject?.bidPrice;
          currentPosition.newPosition = -Number(backLoss);
          otherTeamPosition.newPosition = Number(backProfit);
          if (thirdTeamPosition) {
            thirdTeamPosition.newPosition = Number(backProfit);
          }
          const result = selectionsTemp.map((data) => {
            if (data?.SelectionId == currentPosition?.SelectionId) {
              data.newPosition = currentPosition?.newPosition
                ? parseFloat(currentPosition?.newPosition)
                : 0;
            }
            if (data?.SelectionId == otherTeamPosition?.SelectionId) {
              data.newPosition = otherTeamPosition?.newPosition
                ? parseFloat(otherTeamPosition?.newPosition)
                : 0;
            }
            if (
              thirdTeamPosition &&
              data?.SelectionId == thirdTeamPosition?.SelectionId
            ) {
              data.newPosition = thirdTeamPosition?.newPosition
                ? parseFloat(thirdTeamPosition?.newPosition)
                : 0;
            }
            return data;
          });
          setTieData(result);
        }
      }
    }
  };
  const handelTossPosition = (slipObj) => {
    if (betSlipObject?.bidPrice > 0) {
      let selectionsTemp = [...tossData].map((res) => {
        return {
          ...res,
          newPosition: res?.newPosition || 0,
          position: res?.position || 0,
        };
      });
      let current = selectionsTemp.find((rl) => {
        return rl?.SelectionId === slipObj?.object?.SelectionId;
      });
      let other = selectionsTemp.find((rl) => {
        return rl?.SelectionId !== slipObj?.object?.SelectionId;
      });
      if (Math.abs(current?.position) > 0 || Math.abs(other?.position) > 0) {
        let backProfit = betSlipObject.odds * betSlipObject?.bidPrice;
        let backLoss = betSlipObject?.bidPrice;
        current.newPosition = Number(current?.position) + Number(backProfit);
        other.newPosition = Number(other?.position) - Number(backLoss);
        const result = selectionsTemp.map((data) => {
          if (data?.SelectionId == current?.SelectionId) {
            data.newPosition = current?.newPosition
              ? parseFloat(current?.newPosition)
              : 0;
          }
          if (data?.SelectionId == other?.SelectionId) {
            data.newPosition = other?.newPosition
              ? parseFloat(other?.newPosition)
              : 0;
          }
          return data;
        });
        setTossData(result);
      } else {
        let backProfit = betSlipObject.odds * betSlipObject?.bidPrice;
        let backLoss = -Number(betSlipObject?.bidPrice);
        const result = selectionsTemp.map((data) => {
          if (data?.SelectionId == current?.SelectionId) {
            data.newPosition = backProfit ? parseFloat(backProfit) : 0;
          }
          if (data?.SelectionId == other?.SelectionId) {
            data.newPosition = backLoss ? parseFloat(backLoss) : 0;
          }
          return data;
        });
        setTossData(result);
      }
    }
  };
  const resetPosition = (type) => {
    if (type == "betFair") {
      setRunner((current) =>
        current?.map((res) => {
          return {
            ...res,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "bookmaker") {
      setBookmaker((current) =>
        position?.bookmaker?.length > 0
          ? current?.map((res) => {
              let obj = position?.bookmaker?.find(
                (item) => item?.selectionId == `B${res?.SelectionId}`,
              );
              return {
                ...res,
                position: obj?.position ? obj?.position : 0,
                newPosition: 0,
              };
            })
          : current?.map((res) => {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }),
      );
    } else if (type == "toss") {
      setRunnerToss((current) =>
        current?.map((res) => {
          return {
            ...res,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "sportBook") {
      setSportsBook((current) => {
        return sportsBookPosition?.length > 0
          ? current?.map((res) => {
              let obj = sportsBookPosition?.find(
                (item) =>
                  item?.fancyName == res?.marketName &&
                  res?.id == item?.marketId,
              );
              return obj?.marketId == res?.id &&
                obj?.fancyName == res?.marketName
                ? {
                    ...res,
                    sportsBookSelection: res?.sportsBookSelection?.map(
                      (temp) => {
                        return temp?.id == obj?.selectionId &&
                          temp?.selectionName == obj?.runnerName
                          ? {
                              ...temp,
                              position: obj?.profitAmount,
                              newPosition: 0,
                            }
                          : {
                              ...temp,
                              position: obj?.loseAmount,
                              newPosition: 0,
                            };
                      },
                    ),
                  }
                : res;
            })
          : current.map((res) => {
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((item) => {
                  return { ...item, newPosition: 0 };
                }),
              };
            });
      });
    } else if (type == "tie") {
      setTieData((current) =>
        position?.tie?.length > 0
          ? current?.map((res) => {
              let obj = position?.tie?.find(
                (item) => item.selectionId == res.SelectionId,
              );
              return {
                ...res,
                position:
                  obj.selectionId == res.SelectionId ? obj?.position : 0,
                newPosition: 0,
              };
            })
          : current.map((res) => {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }),
      );
    } else if (type == "toss") {
      setTossData((current) =>
        position?.toss?.length > 0
          ? current?.map((res) => {
              let obj = position?.toss?.find(
                (item) => item.selectionId == res.SelectionId,
              );
              return {
                ...res,
                position:
                  obj.selectionId == res.SelectionId ? obj?.position : 0,
                newPosition: 0,
              };
            })
          : current.map((res) => {
              return {
                ...res,
                position: 0,
                newPosition: 0,
              };
            }),
      );
    } else if (type == "multi") {
      setMarketNew((current) =>
        current?.map((res) => {
          return {
            ...res,
            jsonData: res?.jsonData?.map((newObj) => {
              return {
                ...newObj,
                position: Math.abs(newObj?.position) > 0 ? newObj?.position : 0,
                newPosition: 0,
              };
            }),
          };
        }),
      );
    }
    setResetBetPosition(false);
    resetBetSlipObject();
  };
  const handelBetFairPositionsMulti = (slipObj) => {
    let newselection = marketNew?.find((res) => {
      return res?.mi == slipObj?.mi;
    })?.jsonData;
    let selectionsTemp = [...newselection];
    if (betSlipObject?.bidPrice > 0) {
      if (slipObj?.object?.ib) {
        let backProfit =
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
        let backLoss = Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          selectionsTemp = selectionsTemp?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: Number(rl.position) + backProfit,
              };
            } else {
              return {
                ...rl,
                newPosition: Number(rl.position) - backLoss,
              };
            }
          });
        } else {
          selectionsTemp = selectionsTemp?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: Number(backProfit),
              };
            } else {
              return {
                ...rl,
                newPosition: -Number(backLoss),
              };
            }
          });
        }
      } else {
        let backProfit = Number(betSlipObject?.bidPrice);
        let backLoss =
          Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
        if (Math.abs(selectionsTemp[0]?.position) > 0) {
          selectionsTemp = selectionsTemp?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: Number(rl.position) - backLoss,
              };
            } else {
              return {
                ...rl,
                newPosition: Number(rl.position) + backProfit,
              };
            }
          });
        } else {
          selectionsTemp = selectionsTemp?.map((rl) => {
            if (rl.SelectionId == slipObj?.object?.ri) {
              return {
                ...rl,
                newPosition: -Number(backLoss),
              };
            } else {
              return {
                ...rl,
                newPosition: Number(backProfit),
              };
            }
          });
        }
      }
    }
    setMarketNew((res) => {
      return res?.map((item) => {
        if (item?.mi == slipObj?.mi) {
          return { ...item, jsonData: selectionsTemp };
        } else {
          return item;
        }
      });
    });
  };
  useEffect(() => {
    if (showBetDialog) {
      setTvClass(false);
      if (!isEmpty(betSlipObject)) {
        if (betSlipObject?.playType == "betFair") {
          handelBetFairPositions(betSlipObject);
        } else if (betSlipObject?.playType == "toss") {
          handelBetFairPositionsToss(betSlipObject);
        } else if (betSlipObject?.playType == "fancy") {
          handelFancyPositions(betSlipObject);
        } else if (betSlipObject?.playType == "sportBook") {
          handelSportBookPositions(betSlipObject);
        } else if (betSlipObject?.playType == "bookmaker") {
          handelBookmakerPositions(betSlipObject);
        } else if (betSlipObject?.playType == "tie") {
          handelTiePosition(betSlipObject);
        } else if (betSlipObject?.playType == "toss") {
          handelTossPosition(betSlipObject);
        } else if (betSlipObject?.playType == "multi") {
          handelBetFairPositionsMulti(betSlipObject);
        }
      }
    }
  }, [betSlipObject, showBetDialog]);

  useEffect(() => {
    if (resetBetPosition) {
      resetPosition(betSlipObject?.playType);
    }
  }, [resetBetPosition]);

  const getFancyData = async () => {
    const { status, data: message } = await apiGet(
      apiPath.getFancyOdds + `?eventId=${parmas.eventId}`,
    );
    if (status === 200) {
      if (message.success) {
        if (message?.results?.length > 0) {
          let filtered = categoryArray?.filter((f) =>
            message?.results?.some((item) => item?.categoryType === f.type),
          );
          setFancyHeader(
            filtered?.length > 0
              ? [
                  { type: "All", name: "All" },
                  ...filtered,
                  { type: "Session", name: "Session" },
                ]
              : [
                  { type: "All", name: "All" },
                  { type: "Session", name: "Session" },
                ],
          );
          if (!isEmpty(user)) {
            setFancyPosition((prev) => {
              setFancy(
                message.results.map((res) => {
                  let obj = prev?.find(
                    (item) => item.selectionId == res.selectionId,
                  );

                  return {
                    ...res,
                    odds: res,
                    fancyName: res.name,
                    position: !isEmpty(obj) ? obj?.position : "",
                    newPosition:
                      Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                  };
                }),
              );
              setFancyUpdate(
                message.results.map((res) => {
                  let obj = prev?.find(
                    (item) => item.selectionId == res.selectionId,
                  );
                  return {
                    ...res,
                    odds: res,
                    fancyName: res.name,
                    position: !isEmpty(obj) ? obj?.position : "",
                    newPosition:
                      Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                  };
                }),
              );
              return prev;
            });
          } else {
            setFancy((prev) => {
              return message?.results?.map((res) => {
                let obj = prev?.find(
                  (item) => item.selectionId == res.selectionId,
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                  newPosition:
                    Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                };
              });
            });
            setFancyUpdate((prev) => {
              return message?.results?.map((res) => {
                let obj = prev?.find(
                  (item) => item.selectionId == res.selectionId,
                );
                return {
                  ...res,
                  odds: res,
                  fancyName: res.name,
                  position: !isEmpty(obj) ? obj?.position : "",
                  newPosition:
                    Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
                };
              });
            });
          }
        }
      }
    }
  };

  useEffect(() => {
    getMatchDetails();
    getMatchOdds();
    getSportBookList();
    getFancyData();
  }, [parmas]);

  useEffect(() => {
    let interval = setInterval(() => {
      if (!showBetDialog) {
        getMatchDetails(true);
        getMatchOdds();
        getSportBookList();
        getFancyData();
      }
    }, 30000);
    return () => {
      clearInterval(interval);
    };
  }, [parmas, showBetDialog]);

  useEffect(() => {
    if (!isEmpty(user)) {
      if (!isEmpty(detail)) {
        startTransition(() => {
          getBetPosition();

          getFancyBetPosition();
          getSportBookBetPosition();
        });
      }
    }
  }, [detail]);

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(ruunnerTossObject?.marketId)) {
      getBetPositionToss(ruunnerTossObject?.marketId);
    }
  }, [ruunnerTossObject, user]);

  useEffect(() => {
    if (betPlace?.isPlaced && betPlace?.type == "matched") {
      if (betPlace?.betType == "fancy") {
        getFancyBetPosition();
      } else if (betPlace?.betType == "sportBook") {
        getSportBookBetPosition();
      } else {
        getBetPosition();
        getBetPositionToss(ruunnerTossObject?.marketId);
      }
    } else if (betPlace?.isPlaced && betPlace?.type == "error") {
      resetPosition(betPlace?.betType);
    }
  }, [betPlace]);

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  const alertUser = (e) => {};

  const getSocket = () => {
    if (detail?.eventId && checkRefresh) {
      if (!isEmpty(socketObj)) {
        socketObj.disconnect();
      }
      setCheckRefresh(false);
      let newSocket = "";
      let randomId = user?.user?._id ? user?.user?._id : 112233;
      if (!isEmpty(user)) {
        newSocket = io(
          `${
            detail?.socketUrl ? detail?.socketUrl : process.env.REACT_APP_SOCKET
          }?token=${randomId}&userType=front&eventId=${detail?.eventId}`,
          {
            transports: ["websocket"],
            forceNew: true,
          },
        );
      } else {
        newSocket = io(
          `${
            detail?.socketUrl ? detail?.socketUrl : process.env.REACT_APP_SOCKET
          }?user_id=${randomId}&eventId=${detail?.eventId}`,
          {
            transports: ["websocket"],
            forceNew: true,
          },
        );
      }
      setSocketId(newSocket);
      setSocketObj(newSocket);
      if (!isEmpty(user)) {
        newSocket.on("listenBetFairOdds", listenBetfairOdds);
        newSocket.on("listenBookmakerOdds", listenBookmakerData);
        if (detail?.gameType == "cricket") {
          newSocket.on("listenDiamondFancy", listenDiamondFancy);
        }
        newSocket.on("listenPremiumFancy", listenSportBook);
        newSocket.emit("setPremiumFancy", {
          user_id: user?.user?._id ? user?.user?._id : randomId,
          eventId: parmas.eventId,
        });
      } else {
        if (detail?.gameType == "cricket") {
          newSocket.on("listenDiamondFancy", listenDiamondFancy);
        }
        newSocket.on("listenBetFairOdds", listenBetfairOdds);
        newSocket.on("listenPremiumFancy", listenSportBook);
        newSocket.on("listenBookmakerOdds", listenBookmakerData);
      }
      newSocket.on("disconnect", function () {
        setCheckRefresh(true);
      });
      return () => newSocket.disconnect();
    }
  };
  useEffect(() => {
    if (checkRefresh && detail?.eventId) {
      getSocket();
    }
  }, [checkRefresh, detail]);

  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && !checkRefresh) {
      setCheckRefresh(true);
      if (!isEmpty(socketObj)) {
        socketObj.disconnect();
      }
    } else {
      setCheckRefresh(false);
    }
  });

  useEffect(() => {
    let interval = setInterval(() => {
      getSocket();
    }, 900000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    let header = document.getElementById("header")
      ? Number(document.getElementById("header")?.offsetHeight) + 2
      : 0;
    setScrollHeight(header);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      // Check if scroll is past 200px and page height > 1200
      if (showBetDialog) {
        setTvClass(false);
      } else {
        if (scrollY >= 130 && pageHeight > 1000) {
          setTvClass(true);
        } else {
          setTvClass(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showBetDialog]);

  useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      setControls(false);
    }, 4000);
    return () => window.clearTimeout(timeoutID);
  }, [controls]);
  const [animatedItem, setAnimatedItem] = useState(null);

  const addToFavioute = async (id, favoriteType, favoriteMarketId, market) => {
    const { status, data: response_users } = await apiGet(
      apiPath.addToFavourite +
        `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${
          detail?.eventType
        }&market=${market ? market : ""}`,
    );

    if (response_users?.success) {
      getMatchDetails("fav");
    }
  };

  const getMatchData = async (id) => {
    const { status, data: response_users } = await apiGet(
      apiPath.getMatchOdds + `?marketId=${!isEmpty(id) ? id : parmas.marketId}`,
    );
    if (status === 200) {
      if (response_users.success) {
        const socket_data = response_users?.results;
        if (
          socket_data &&
          socket_data?.eventId &&
          parmas?.eventId == socket_data?.eventId
        ) {
          if (socket_data.ms) {
            setBetFairMs(socket_data.ms);
          }
          if (socket_data.rt?.length) {
            const back_odds = socket_data?.rt?.filter((rt) => rt.ib) || [];
            const lay_odds = socket_data?.rt?.filter((rt) => !rt.ib) || [];
            setRunnerBackOdds(back_odds);
            setRunnerLayOdds(lay_odds);
            setTotalMatched(socket_data?.totalMatched);
          }
          if (!isEmpty(id)) {
            setCheckRefresh(true);
          }
        }
      }
    }
  };
  const iframeRef = useRef(null);
  const handleIframeLoad = () => {
    const handleMessage = (event) => {
      // security check
      if (event.origin !== "https://scorecard.oddstrad.com") return;

      const data = event.data;

      // resize event
      if (data.height && iframeRef.current) {
        iframeRef.current.style.height = data.height + "px";
      }

      // custom click event
      if (data.type === "FOOTER_CLICKED") {
      }
    };

    window.addEventListener("message", handleMessage);
  };
  const displayScore = () => {
    return (
      !isEmpty(detail?.scoreURL) && (
        <iframe
          className="responsive-iframe w-100"
          style={{
            overflow: "hidden",
            height: detail?.screenScore === "full" ? "270px" : "141px",
            backgroundColor: "#000000",
            width: "100%",
          }}
          id="scoreId"
          src={detail?.scoreURL}
        />
      )
    );
  };

  const matchedScore = scoreAll?.find(
    (res) => res?.eventId === detail?.eventId,
  );
  const score = matchedScore?.score ?? detail?.outcome ?? "";
  let premiunFancyCondition = isEmpty(
    blockLimit?.find((res) => {
      return res?.betfairId == -1;
    }),
  );
  const handelCondition = () => {
    if (!isEmpty(user)) {
      if (detail?.status == "in_play") {
        if (detail?.channel != "false" && Number(detail?.channel) > 0) {
          return true;
        } else {
          return detail?.adsStatus;
        }
      }
    }
    return false;
  };

  const handelConditionOnlyScoreboard = () => {
    if (isEmpty(user)) {
      if (!isEmpty(detail.scoreId) && !isEmpty(detail.scoreURL) && detail?.status == "in_play") {
        return true;
      }
    }
    return false;
  };

  const handelStaticScoreboard = () => {
    if (isEmpty(detail.scoreId) || isEmpty(detail.scoreURL) || detail?.status == "active") {
      return true;
    }
    return false;
  };

  const [hlsTvLoaded, setHlsTvLoaded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
  }, [detail?.eventId]);

  useEffect(() => {
    setHlsTvLoaded(false);
  }, [detail?.channel, detail?.adsStatus, detail?.adsContent]);
  let showFancy =
    detail?.hasFancy &&
    !["Winner", "Win"].includes(detail?.market) &&
    detail?.gameType === "cricket";
  let showSportbook = detail?.premiumFancy === "on" || detail?.hasSportBook;


// useEffect(() => {
//   if (isEmpty(detail) || !detail?.eventId) return;

//   let matchOdds = detail.matchOdds;

//   if (!detail.eventId.includes("-1")) {
//     matchOdds = "off";
//   } else if (totalMatched < 20000 && detail.eventType == "4") {
//     matchOdds = "off";
//   } else if (totalMatched < 50000 && detail.eventType != "4") {
//     matchOdds = "off";
//   }

//   if (matchOdds !== detail.matchOdds) {
//     setDetail((prev) => ({ ...prev, matchOdds }));
//   }
// }, [totalMatched, detail]);

  return (
    <div>
      <LayoutComponent visibilityType={true} className="position-relative">
        <div className="full-market">
          {handelCondition() && (
            <>
              <div class="topnav">
                <p
                  onClick={() => setTopTab("live")}
                  class={topTab === "live" ? "active" : ""}
                >
                  Live
                </p>
                <p
                  onClick={() => setTopTab("scoreboard")}
                  class={topTab === "scoreboard" ? "active" : ""}
                >
                  ScoreBoard
                </p>
              </div>
              <div>
                {topTab === "live" ? (
                  <div className="live-header">
                    <span
                      className="d-flex align-items-center"
                      style={{
                        width: "37%",
                        fontSize: ".9285714285714286rem",
                      }}
                    >
                      {detail?.eventName?.split(" v ")[0]}
                    </span>
                    {!isEmpty(score) ? (
                      <span
                        className="score_color d-flex justify-content-center align-items-center"
                        style={{
                          width: "25%",
                          fontSize: ".9285714285714286rem",
                        }}
                      >
                        {score}
                      </span>
                    ) : (
                      "-"
                    )}
                    <span
                      className="d-flex justify-content-end align-items-center"
                      style={{
                        width: "37%",
                        fontSize: ".9285714285714286rem",
                      }}
                    >
                      {detail?.eventName?.split(" v ")[1]}
                    </span>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </>
          )}

          {handelConditionOnlyScoreboard() && displayScore()}
          {handelStaticScoreboard() && !handelCondition() && (
            <div
              style={{
                width: "100%",
                background: "rgb(255, 255, 255)",
                height: "270px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              {detail?.eventName}
            </div>
          )}
          {handelCondition() ? (
            topTab === "live" ? (
              <div className={` relative`}>
                {tvClass && (
                  <div className={"tv-outer"}>
                    <ReactPlayer
                      url={null} // No video source
                      playing={false} // Don’t auto-play
                      controls={false} // No controls
                      light={true} // Enable light mode
                      width="100%"
                      height="250px"
                      style={{ backgroundColor: "black" }} // Make background black
                    />
                  </div>
                )}
                <div
                  // style={
                  //   ref?.current?.getSecondsLoaded() == null ||
                  //   ref?.current?.getSecondsLoaded() == 0
                  //     ? { minHeight: "15rem" }
                  //     : {}
                  // }
                  className={tvClass ? "is-outside" : "tv-outer"}
                >
                  {tvClass && (
                    <i
                      className="icon icon-close is-outsite-icon"
                      onClick={() => {
                        setTvClass(false);
                        setTopTab("scoreboard");
                      }}
                      style={{ color: "#fff", zIndex: `99`, fontSize: "17px" }}
                    />
                  )}
                  {/* <>
                    {!hlsTvLoaded && (
                      <div
                        className="tv-control live_img"
                        style={{
                          padding: "0",
                          position: "absolute",
                          margin: "0",
                          width: "100%",
                          height: "100%",
                          zIndex: 1,
                        }}
                      >
                        <img
                          src={TvLoader}
                          alt="Thumbnail"
                          onClick={() => setControls(true)}
                          style={{
                            overflowY: "hidden",
                            height: "100%",
                            width: "100%",
                            overflowX: "hidden",
                          }}
                        />
                      </div>
                    )}
                    <div className="is-outsite-icon-new">
                      <img src={RightLogoTv} />
                    </div>

                    <iframe
                      title="Live TV Player"
                      src={`https://oddsdata.org/score/d23663bded9c894decd4a4670a596b0a50ad9d7a/${detail?.channel}`}
                      id="ContentPlaceHolder1_myFrame1"
                      onLoad={() => setHlsTvLoaded(true)}
                      style={{
                        //   position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "233px",
                        border: "none",
                        overflow: "none",
                        opacity: isLoaded ? 1 : 0,
                        transition: "opacity 0.3s ease-in-out",
                      }}
                      className="sc-dUjcNx eLUYUT"
                    />
                  </> */}
                  {detail?.allowCustomTv ? (
                    <>
                      {!isLoaded && (
                        <div
                          className="tv-control live_img"
                          style={{
                            padding: "0",
                            position: "absolute",
                            margin: "0",
                            width: "100%",
                            height: "100%",
                            zIndex: 1,
                          }}
                        >
                          <img
                            src={TvLoader}
                            alt="Thumbnail"
                            onClick={() => setControls(true)}
                            style={{
                              overflowY: "hidden",
                              height: "100%",
                              width: "100%",
                              overflowX: "hidden",
                            }}
                          />
                        </div>
                      )}
                      <div className="is-outsite-icon-new">
                        <img src={RightLogoTv} />
                      </div>
                      <StreamingPlayer
                        eventId={detail?.eventId}
                        isLoaded={isLoaded}
                        setIsLoaded={setIsLoaded}
                      />
                    </>
                  ) : !detail?.allowCustomTv ? (
                    <>
                      {!hlsTvLoaded && (
                        <div
                          className="tv-control live_img"
                          style={{
                            padding: "0",
                            position: "absolute",
                            margin: "0",
                            width: "100%",
                            height: "100%",
                            zIndex: 1,
                          }}
                        >
                          <img
                            src={TvLoader}
                            alt="Thumbnail"
                            onClick={() => setControls(true)}
                            style={{
                              overflowY: "hidden",
                              height: "100%",
                              width: "100%",
                              overflowX: "hidden",
                            }}
                          />
                        </div>
                      )}
                      <div className="is-outsite-icon-new">
                        <img src={RightLogoTv} />
                      </div>
                      <iframe
                        ref={ref}
                        title="Live TV Player Custom"
                        src={detail?.adsContent}
                        id="ContentPlaceHolder1_myFrame1"
                        onLoad={() => setHlsTvLoaded(true)}
                        style={{
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "233px",
                          border: "none",
                          overflow: "hidden",
                          opacity: hlsTvLoaded ? 1 : 0,
                          transition: "opacity 0.3s ease-in-out",
                        }}
                        className="sc-dUjcNx eLUYUT"
                      />
                    </>
                  ) : (
                    <Fade cascade duration={1000}>
                      <div
                        className="tv-control live_img"
                        style={{
                          padding: "0",
                          position: "absolute",
                          margin: "0",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <img
                          src={TvLoader}
                          alt="Thumbnail"
                          onClick={() => setControls(true)}
                          style={{
                            overflowY: "hidden",
                            height: "100%",
                            width: "100%",
                            overflowX: "hidden",
                            overflowY: "hidden",
                          }}
                        />
                      </div>
                    </Fade>
                  )}
                </div>
              </div>
            ) : (
              displayScore()
            )
          ) : (
            !isEmpty(user) && displayScore()
          )}

          {!parly ? (
            <>
              {(!isEmpty(profileData) && profileData?.minMatchingAmount > 0
                ? totalMatched > profileData?.minMatchingAmount
                : true) && (
                <>
                  <div
                    className="balance-label-detail position-relative text-start d-flex justify-content-between exchange-label"
                    style={{ marginTop: `-6px` }}
                  >
                    <span>Exchange</span>
                    <div className="text-yellow balance-label-inner">
                      {totalMatched > 0 && (
                        <>
                          <span>Matched</span>
                          <strong
                            className=""
                            style={{
                              fontSize: `.7142857143rem`,
                              padding: `.5rem`,
                            }}
                          >
                            USD {priceFormat(totalMatched)}
                          </strong>
                          {totalMatched < 10000 && (
                            <strong className="bg-danger rounded text-white low-button">
                              Low
                            </strong>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  {detail?.matchOdds == "on" && runner?.length > 0 && (
                    <Runner
                      ms={detail?.matchOdds == "on" ? ms : 3}
                      addToFavioute={addToFavioute}
                      parmas={parmas}
                      user={user}
                      setRunner={setRunner}
                      oldBack={
                        detail?.matchOdds == "on" ? runnerBackOddsOld : []
                      }
                      oldLay={detail?.matchOdds == "on" ? runnerLayOddsOld : []}
                      detail={detail}
                      getBetPosition={getBetPosition}
                      tieData={tieData}
                      setMarketDepthData={setMarketDepthData}
                      marketName={marketName}
                      position={
                        position?.betFair?.length > 0 ? position?.betFair : []
                      }
                      setMarketName={setMarketName}
                      totalMatched={totalMatched}
                      runner={runner}
                      favouriteList={favouriteList}
                      market={marketNew}
                      backOdds={detail?.matchOdds == "on" ? runnerBackOdds : []}
                      layOdds={detail?.matchOdds == "on" ? runnerLayOdds : []}
                      back_oddsTie={back_oddsTie}
                      lay_oddsTie={lay_oddsTie}
                      setLimit={setLimit}
                      scrollHeight={scrollHeight}
                      getMatchData={getMatchData}
                      setBetSlipObject={setBetSlipObject}
                      setShowBetDialog={setShowBetDialog}
                      setShowMarketDepthPopup={setShowMarketDepthPopup}
                      handelBetFairPositions={handelBetFairPositions}
                      profileData={
                        detail?.matchSetting?.length > 0
                          ? { ...detail, arrayCheck: "details" }
                          : { ...profileData, arrayCheck: "profile" }
                      }
                    />
                  )}
                </>
              )}

              {detail?.bookMaker == "on" &&
                detail?.gameType == "cricket" &&
                bookmaker?.length > 0 && (
                  <Bookmaker
                    user={user}
                    detail={detail}
                    displayType="bookmaker"
                    bookmaker={bookmaker}
                    ms={bookmakerMs}
                    addToFavioute={addToFavioute}
                    backOdds={bookmakerBackOdds}
                    position={
                      position?.bookmaker?.length > 0 ? position?.bookmaker : []
                    }
                    layOdds={bookmakerLayOdds}
                    betSlipObject={betSlipObject}
                    showBetDialog={showBetDialog}
                    setLimit={setLimit}
                    favouriteList={favouriteList}
                    scrollHeight={scrollHeight}
                    profileData={
                      detail?.matchSetting?.length > 0
                        ? { ...detail, arrayCheck: "details" }
                        : { ...profileData, arrayCheck: "profile" }
                    }
                    setBetSlipObject={setBetSlipObject}
                    setShowBetDialog={setShowBetDialog}
                  />
                )}

              {/* {detail?.matchOdds == "on" &&
                ruunnerToss?.length > 0 &&
                !isEmpty(ruunnerTossObject) && (
                  <RunnerToss
                    ms={detail?.matchOdds == "on" ? ruunnerTossOdds?.ms : 3}
                    addToFavioute={addToFavioute}
                    user={user}
                    eventId={parmas?.eventId}
                    marketId={ruunnerTossObject?.marketId}
                    detail={detail}
                    getBetPosition={getBetPosition}
                    setMarketDepthData={setMarketDepthData}
                    marketName={"To Win the Toss"}
                    position={
                      ruunnerTossPosition?.length > 0 ? ruunnerTossPosition : []
                    }
                    totalMatched={ruunnerTossOdds?.totalMatched}
                    runner={ruunnerToss}
                    favouriteList={favouriteList}
                    backOdds={
                      detail?.matchOdds == "on"
                        ? ruunnerTossOdds?.back_odds
                        : []
                    }
                    layOdds={
                      detail?.matchOdds == "on" ? ruunnerTossOdds?.lay_odds : []
                    }
                    oldBack={
                      detail?.matchOdds == "on" ? ruunnerTossOdds?.oldBack : []
                    }
                    oldLay={
                      detail?.matchOdds == "on" ? ruunnerTossOdds?.oldLay : []
                    }
                    setLimit={setLimit}
                    scrollHeight={scrollHeight}
                    getMatchData={getMatchData}
                    setBetSlipObject={setBetSlipObject}
                    setShowBetDialog={setShowBetDialog}
                    setShowMarketDepthPopup={setShowMarketDepthPopup}
                    handelBetFairPositions={handelBetFairPositions}
                    profileData={
                      detail?.matchSetting?.length > 0
                        ? { ...detail, arrayCheck: "details" }
                        : { ...profileData, arrayCheck: "profile" }
                    }
                  />
                )} */}

              {(showFancy || showSportbook) && (
                <div className="fancy-sport-tab p-2">
                  <div className="fancy-sport-header">
                    <div className="d-flex align-items-center taber">
                      {showFancy && (
                        <>
                          <Button
                            className={
                              fancySportTab === "fancy" && "active-taber"
                            }
                            onClick={() => {
                              setFancySportTab("fancy");
                              setFancyHeaderKey("All");
                              if (!isEmpty(parmas?.tab)) {
                                handleClick("fancy");
                              } else {
                                navigate(`${location.pathname}/fancy`, {
                                  replace: true,
                                });
                              }
                            }}
                          >
                            Fancybet
                          </Button>
                          <Button
                            className={
                              fancySportTab === "fancyPlus" && "active-taber"
                            }
                            onClick={() => {
                              setFancySportTab("fancyPlus");
                              setFancyHeaderKey("All");
                              if (!isEmpty(parmas?.tab)) {
                                handleClick("fancyPlus");
                              } else {
                                navigate(`${location.pathname}/fancyPlus`, {
                                  replace: true,
                                });
                              }
                            }}
                          >
                            Fancy Plus
                          </Button>{" "}
                        </>
                      )}

                      {showSportbook && (
                        <Button
                          className={
                            fancySportTab === "sport" && "active-taber"
                          }
                          onClick={() => {
                            setFancySportTab("sport");
                            if (!isEmpty(parmas?.tab)) {
                              handleClick("sport");
                            } else {
                              navigate(`${location.pathname}/sport`, {
                                replace: true,
                              });
                            }
                          }}
                        >
                          {detail?.eventType == 4 ? "Sportbook" : "Sportbook"}
                        </Button>
                      )}
                    </div>
                  </div>
                  {showFancy &&
                  (fancySportTab === "fancy" ||
                    fancySportTab === "fancyPlus") ? (
                    <FancyBet
                      user={user}
                      detail={detail}
                      addToFavioute={addToFavioute}
                      type={fancySportTab}
                      position={fancyPosition}
                      handleShowInfo={handleShowInfo}
                      data={fancyUpdated}
                      setLimit={setLimit}
                      favouriteList={favouriteList}
                      header={fancyHeader}
                      fancyHeaderKey={fancyHeaderKey}
                      tvClass={tvClass}
                      scrollHeight={scrollHeight}
                      handelChangeFancyHeader={handelChangeFancyHeader}
                      setShowPosition={setShowPosition}
                      profileData={
                        detail?.matchSetting?.length > 0
                          ? { ...detail, arrayCheck: "details" }
                          : { ...profileData, arrayCheck: "profile" }
                      }
                    />
                  ) : detail?.eventName?.includes(" T10 ") ? (
                    ""
                  ) : (
                    showSportbook &&
                    fancySportTab === "sport" && (
                      <SportsBook
                        handleShowInfo={handleShowInfo}
                        data={sportsBook}
                        user={user}
                        addToFavioute={addToFavioute}
                        detail={detail}
                        position={sportsBookPosition}
                        favouriteList={favouriteList}
                        setLimit={setLimit}
                        scrollHeight={scrollHeight}
                        tvClass={tvClass}
                        setBetSlipObject={setBetSlipObject}
                        setShowBetDialog={setShowBetDialog}
                        profileData={
                          detail?.matchSetting?.length > 0
                            ? { ...detail, arrayCheck: "details" }
                            : { ...profileData, arrayCheck: "profile" }
                        }
                      />
                    )
                  )}
                </div>
              )}
            </>
          ) : (
            premiunFancyCondition && (
              <SportsBook
                handleShowInfo={handleShowInfo}
                data={sportsBook}
                user={user}
                detail={detail}
                addToFavioute={addToFavioute}
                setLimit={setLimit}
                scrollHeight={scrollHeight}
                tvClass={tvClass}
                position={sportsBookPosition}
                favouriteList={favouriteList}
                setBetSlipObject={setBetSlipObject}
                setActiveSportBook={setActiveSportBook}
                activeSportBook={activeSportBook}
                setShowBetDialog={setShowBetDialog}
                profileData={
                  detail?.matchSetting?.length > 0
                    ? { ...detail, arrayCheck: "details" }
                    : { ...profileData, arrayCheck: "profile" }
                }
              />
            )
          )}
        </div>
        {showWidget && widgetsData?.length > 0 && (
          <SportWidget data={widgetsData} detail={detail} />
        )}
        {showInfo && (
          <Info handleShowInfo={handleShowInfo} sportRules={sportRules} />
        )}
        {showMarketDepthPopup && (
          <MarketDepth
            data={marketDepthData}
            detail={detail}
            setShowMarketDepthPopup={setShowMarketDepthPopup}
          />
        )}
        {showMyBet && <MyBets handleShowBet={handleShowBet} />}
      </LayoutComponent>
    </div>
  );
};

export default FullMarket;
